import { render, staticRenderFns } from "./donation.vue?vue&type=template&id=00c62744&scoped=true&"
import script from "./donation.vue?vue&type=script&lang=js&"
export * from "./donation.vue?vue&type=script&lang=js&"
import style0 from "./donation.vue?vue&type=style&index=0&id=00c62744&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c62744",
  null
  
)

export default component.exports